import {
    formatDigitalBindingLabel,
    RUN_HINT_KEY_TOKEN,
    toActionBarBindingId,
    type ActionBarHotkeyTarget,
    type DigitalInputBindingId,
    type InputBindings,
} from '@sorrem/shared';

/** Matches the `{skill:<skill id>}` tokens in a hint's text; the id is group 1. */
const SKILL_KEY_TOKEN = /\{skill:([a-z0-9-]+)\}/g;

/** The player's key for an input binding (`1`, `Shift+LMB`), or "unbound". */
function formatBindingKey(bindings: InputBindings, id: DigitalInputBindingId): string {
    const first = bindings[id][0];
    return first ? formatDigitalBindingLabel(first) : 'unbound';
}

/**
 * A run hint's text with each `{key:<binding id>}` token replaced by the
 * player's key for it (`1`, `Shift+LMB`), so a moved key reads right, and
 * each `{skill:<skill id>}` token by the key of the action-bar slot
 * (`actionBar`) the skill is on, so a moved skill does too. An unbound
 * input reads "unbound", a skill on no slot "no key"; an id that is no
 * binding is left as written.
 */
export function formatRunHint(text: string, bindings: InputBindings, actionBar: readonly ActionBarHotkeyTarget[] = []): string {
    return text
        .replace(RUN_HINT_KEY_TOKEN, (token, id: string) => (
            Object.hasOwn(bindings, id) ? formatBindingKey(bindings, id as DigitalInputBindingId) : token
        ))
        .replace(SKILL_KEY_TOKEN, (_token, skillId: string) => {
            const index = actionBar.findIndex((target) => target?.kind === 'skill' && target.skillId === skillId);
            const bindingId = toActionBarBindingId(index);
            return bindingId === undefined ? 'no key' : formatBindingKey(bindings, bindingId);
        });
}
